module.exports = __webpack_public_path__ + "static/img/logo.d1c273e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/common/logo.png
// module id = OK6f
// module chunks = 256